import { HighlightStyle } from '@codemirror/language';
import { tags } from '@lezer/highlight';

export const highlightStyle = HighlightStyle.define([
  { tag: tags.comment, class: 'cm-comment' },
  { tag: tags.lineComment, class: 'cm-comment' },
  { tag: tags.blockComment, class: 'cm-comment' },
  { tag: tags.docComment, class: 'cm-comment' },
  { tag: tags.docString, class: 'cm-comment' },
  { tag: tags.name, class: 'cm-variable' },
  { tag: tags.variableName, class: 'cm-variable' },
  { tag: tags.typeName, class: 'cm-variable' },
  { tag: tags.className, class: 'cm-variable' },
  { tag: tags.string, class: 'cm-string' },
  { tag: tags.character, class: 'cm-string' },
  { tag: tags.attributeName, class: 'cm-string' },
  { tag: tags.regexp, class: 'cm-regexp' },
  { tag: tags.number, class: 'cm-number' },
  { tag: tags.integer, class: 'cm-number' },
  { tag: tags.float, class: 'cm-number' },
  { tag: tags.atom, class: 'cm-atom' },
  { tag: tags.bool, class: 'cm-atom' },
  { tag: tags.null, class: 'cm-atom' },
  { tag: tags.keyword, class: 'cm-keyword' },
  { tag: tags.self, class: 'cm-keyword' },
  { tag: tags.function, class: 'cm-keyword' },
  { tag: tags.operator, class: 'cm-operator' },
  { tag: tags.operatorKeyword, class: 'cm-operator' },
  { tag: tags.controlKeyword, class: 'cm-operator' },
  { tag: tags.derefOperator, class: 'cm-operator' },
  { tag: tags.arithmeticOperator, class: 'cm-operator' },
  { tag: tags.logicOperator, class: 'cm-operator' },
  { tag: tags.bitwiseOperator, class: 'cm-operator' },
  { tag: tags.compareOperator, class: 'cm-operator' },
  { tag: tags.updateOperator, class: 'cm-operator' },
  { tag: tags.typeOperator, class: 'cm-operator' },
  { tag: tags.controlOperator, class: 'cm-operator' },
  { tag: tags.definitionKeyword, class: 'cm-keyword' },
  { tag: tags.tagName, class: 'cm-tag' },
  { tag: tags.heading, class: 'cm-tag' },
  { tag: tags.heading1, class: 'cm-tag' },
  { tag: tags.heading2, class: 'cm-tag' },
  { tag: tags.heading3, class: 'cm-tag' },
  { tag: tags.heading4, class: 'cm-tag' },
  { tag: tags.heading5, class: 'cm-tag' },
  { tag: tags.heading6, class: 'cm-tag' },
  { tag: tags.list, class: 'cm-tag' },
  { tag: tags.quote, class: 'cm-tag' },
  { tag: tags.emphasis, class: 'cm-tag' },
  { tag: tags.strong, class: 'cm-tag' },
  { tag: tags.link, class: 'cm-tag' },
  { tag: tags.propertyName, class: 'cm-property' },
  { tag: tags.attributeName, class: 'cm-attribute' }
]);
